// 9fbef606107a605d69c0edbcd8029e5d
import { breakpoints } from '../../../../../../styles/themes/TCP/mediaQuery';

const dotsClass = 'slick-dots';
const CAROUSEL_OPTIONS = {
  autoplay: false,
  arrows: false,
  fade: false,
  speed: 0,
  dots: true,
  dotsClass,
  swipe: true,
  slidesToShow: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: breakpoints.values.lg - 1,
      settings: {
        arrows: false,
      },
    },
  ],
};

const CAROUSEL_OPTIONS_NEW_DESIGN = {
  autoplay: false,
  fade: false,
  speed: 0,
  dotsClass,
  swipe: true,
  slidesToShow: 1,
  infinite: false,
  responsive: [
    {
      breakpoint: breakpoints.values.lg - 1,
      settings: {
        arrows: false,
        swipeToSlide: true,
        dots: true,
        dotsClass,
      },
    },
  ],
};

const COMBINED_KITS_CONFIG = {
  autoplay: false,
  fade: false,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  dots: false,
  dotsClass: 'slick-dots',
  lazyLoad: true,
  responsive: [
    {
      breakpoint: breakpoints.values.lg - 1,
      settings: {
        dots: false,
      },
    },
    {
      breakpoint: breakpoints.values.md, // Add your breakpoint for tablets
      settings: {
        slidesToScroll: 2, // Number of slides to scroll on tablets
        arrows: false, // Hide arrows on tablets
      },
    },
    {
      breakpoint: breakpoints.values.sm, // Add your breakpoint for mobile
      settings: {
        slidesToScroll: 1, // Number of slides to scroll on mobile
        arrows: false, // Hide arrows on mobile
      },
    },
  ],
};
const COMBINED_KITS_CONFIG_UNMOUNT = {
  autoplay: false,
  fade: false,
  autoplaySpeed: 3000,
  slidesToScroll: 1,
  infinite: false,
  arrows: true,
  dots: false,
  dotsClass,
  lazyLoad: false,
  slidesToShow: 9,
  responsive: [
    {
      settings: {
        dots: false,
      },
    },
    {
      settings: {
        slidesToScroll: 2, // Number of slides to scroll on tablets
        arrows: false, // Hide arrows on tablets
      },
    },
    {
      settings: {
        slidesToScroll: 1, // Number of slides to scroll on mobile
        arrows: false, // Hide arrows on mobile
      },
    },
  ],
};
const IMG_DATA = {
  imgConfig: [`t_bundle_img_m`, `t_bundle_img_t`, `t_bundle_img_d`],
};

export {
  CAROUSEL_OPTIONS,
  IMG_DATA,
  CAROUSEL_OPTIONS_NEW_DESIGN,
  COMBINED_KITS_CONFIG,
  COMBINED_KITS_CONFIG_UNMOUNT,
};
